<template>
  <div class="list-item with-icon">
    <v-list-item-avatar tile>
      <v-img height="36px" contain src="@/assets/svg/offer_list_icon.svg" />
    </v-list-item-avatar>
    <v-list-item-content>
      <div class="item-right">
        <div class="description">
          <div class="d-flex" :class="{ 'flex-column': isMobile }">
            <span class="font-weight-bold">
              {{ offer.candidate || offer.title }}
            </span>
          </div>
          <div class="status-wrapper" v-if="offer.candidate">
            <span class="mr-1">{{ offer.title }}</span>
          </div>
        </div>
        <Chip
          :color="getColorByStatus(offer.status)"
          class="chip--status"
          shrink
        >
          {{ offer.status | upperCase }}
        </Chip>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
import { getColorByStatus } from "@/utils/offers";
import Chip from "@/components/common/Chip";

export default {
  props: {
    offer: {
      type: Object,
      required: true
    }
  },
  components: {
    Chip
  },
  methods: {
    getColorByStatus
  }
};
</script>

<style lang="scss" scope>
.offers {
  .list-item {
    .description {
      min-height: 50px !important;
    }
  }
}
</style>
